import api from "./axios";

const base = (mintSpaceId) => `/mint-space/${mintSpaceId}/live-stream`;

const withInstance = (instanceId) =>
  instanceId ? { instanceId } : {};

export const getLiveStreamSession = async (mintSpaceId, instanceId = null) => {
  const response = await api.get(`${base(mintSpaceId)}/session`, {
    params: withInstance(instanceId),
  });
  return response.data;
};

export const startLiveStreamSession = async (mintSpaceId, { instanceId, title } = {}) => {
  const response = await api.post(
    `${base(mintSpaceId)}/session/start`,
    { title: title || "", instanceId },
    { params: withInstance(instanceId) }
  );
  return response.data;
};

export const endLiveStreamSession = async (mintSpaceId, instanceId = null) => {
  const response = await api.post(
    `${base(mintSpaceId)}/session/end`,
    { instanceId },
    { params: withInstance(instanceId) }
  );
  return response.data;
};

export const getLiveStreamToken = async (
  mintSpaceId,
  { instanceId, asPublisher = false } = {}
) => {
  const response = await api.post(
    `${base(mintSpaceId)}/session/token`,
    { instanceId, asPublisher },
    { params: withInstance(instanceId) }
  );
  return response.data;
};

export const requestLiveStreamStageJoin = async (mintSpaceId, instanceId) => {
  const response = await api.post(
    `${base(mintSpaceId)}/session/join-request`,
    { instanceId },
    { params: withInstance(instanceId) }
  );
  return response.data;
};

export const decideLiveStreamStageJoin = async (
  mintSpaceId,
  instanceId,
  { userId, accept }
) => {
  const response = await api.post(
    `${base(mintSpaceId)}/session/join-request/decide`,
    { instanceId, userId, accept },
    { params: withInstance(instanceId) }
  );
  return response.data;
};

export const listLiveStreamFiles = async (mintSpaceId, instanceId) => {
  const response = await api.get(`${base(mintSpaceId)}/files`, {
    params: withInstance(instanceId),
  });
  return response.data;
};

export const uploadLiveStreamFile = async (mintSpaceId, instanceId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  if (instanceId) formData.append("instanceId", instanceId);
  const response = await api.post(`${base(mintSpaceId)}/files`, formData, {
    params: withInstance(instanceId),
  });
  return response.data;
};

export const downloadLiveStreamFile = async (mintSpaceId, fileId, instanceId) => {
  const response = await api.get(
    `${base(mintSpaceId)}/files/${fileId}/download`,
    {
      params: withInstance(instanceId),
      responseType: "blob",
    }
  );
  return response.data;
};

export const deleteLiveStreamFile = async (mintSpaceId, fileId, instanceId) => {
  const response = await api.delete(`${base(mintSpaceId)}/files/${fileId}`, {
    params: withInstance(instanceId),
  });
  return response.data;
};
